import { fullName } from "utils/fullName";

type TransactionUser = {
  id?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
} | null;

export type TransactionEmployeeOption = {
  id: string;
  firstName: string;
  lastName?: string | null;
  email: string;
};

/** Dedupe by user id; stable sort by display name. */
export function uniqueEmployeesFromTransactionUsers(
  users: TransactionUser[],
): TransactionEmployeeOption[] {
  const map = new Map<string, TransactionEmployeeOption>();
  for (const user of users) {
    if (!user?.id) continue;
    if (!map.has(user.id)) {
      map.set(user.id, {
        id: user.id,
        firstName: user.firstName ?? "",
        lastName: user.lastName ?? "",
        email: user.email ?? "",
      });
    }
  }
  return Array.from(map.values()).sort((a, b) =>
    fullName(a).localeCompare(fullName(b)),
  );
}
